import React from 'react'
import PropTypes from 'prop-types'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts'

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div style={{ backgroundColor: '#fff', padding: '10px', border: '1px solid #ccc', borderRadius: '4px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
        <p style={{ margin: '0 0 5px 0', fontWeight: 'bold' }}>{`${label}`}</p>
        <p style={{ margin: '0', color: '#6B46C1' }}>{`Maven: ${payload[0]?.value || 0}`}</p>
        <p style={{ margin: '0', color: '#14B8A6' }}>{`Buyer: ${payload[1]?.value || 0}`}</p>
      </div>
    )
  }
  return null
}

const CustomLegend = (props) => {
  const { payload } = props
  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px', gap: '20px' }}>
      {payload.map((entry, index) => (
        <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          <div 
            style={{ 
              width: '12px', 
              height: '12px', 
              backgroundColor: entry.color,
              borderRadius: '2px'
            }}
          />
          <span style={{ fontSize: '14px', color: entry.color, fontWeight: '500' }}>
            {entry.value}
          </span>
        </div>
      ))}
    </div>
  )
}

const MavenBuyerChart = ({ data = [] }) => {
  // Transform data for the chart
  const chartData = data.map(item => ({
    category: item.category,
    maven: item.maven,
    buyer: item.buyer
  }))

  return (
    <div>
      <CustomLegend payload={[
        { value: 'Maven', color: '#14B8A6' },
        { value: 'Buyer', color: '#6B46C1' }
      ]} />
      <ResponsiveContainer width="100%" height={200}>
        <BarChart
          data={chartData}
          margin={{
            top: 10,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis 
            dataKey="category" 
            tick={{ fontSize: 12, fill: '#666' }}
            interval={0}
            axisLine={false}
            tickLine={false}
          />
          <YAxis 
            tick={{ fontSize: 12, fill: '#666' }} 
            axisLine={false}
            tickLine={false}
            domain={[0, 400]}
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="maven" fill="#14B8A6" name="Maven" radius={[2, 2, 0, 0]} />
          <Bar dataKey="buyer" fill="#6B46C1" name="Buyer" radius={[2, 2, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}

MavenBuyerChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string.isRequired,
      maven: PropTypes.number.isRequired,
      buyer: PropTypes.number.isRequired
    })
  )
}

export default MavenBuyerChart